/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITipoContribuyente from 'Infotrack@Modelos/administracion/tipoContribuyente/entidades/tipoContribuyente';
import React from 'react';
import TipoContribuyenteCM from '../controladorModelo/tipoContribuyenteCM';
import { acciones, IEstadoTipoContribuyente } from '../reductorTipoContribuyente';
import FormularioTipoContribuyenteVista from '../vista/formularioTipoContribuyenteVista';

const estadoInicial: ITipoContribuyente = {
    CodigoTipoContribuyente: '',
    NombreTipoContribuyente: '',
    EstadoTipoContribuyente: true,
};
const tipoContribuyenteCM = new TipoContribuyenteCM();

const FormularioTipoContribuyenteCV: React.FunctionComponent = () => {
    const [{ estadoFormulario, tipoFormulario, entidadTipoContribuyente }, dispatch] = useProveedor<
        IEstadoTipoContribuyente
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<ITipoContribuyente>(estadoInicial);

    React.useEffect(() => {
        if (entidadTipoContribuyente && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadTipoContribuyente);
        } else {
            reiniciar();
        }
    }, [entidadTipoContribuyente]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionTipoContribuyente = () => {
        if (tipoContribuyenteCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarTipoContribuyente,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarTipoContribuyente = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            tipoContribuyenteCM.crearTipoContribuyente(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        } else {
            tipoContribuyenteCM.editarTipoContribuyente(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        }
    };

    return (
        <FormularioTipoContribuyenteVista
            accionCrearEditar={confirmarCreacionEdicionTipoContribuyente}
            cambiarInfoFomulario={alCambiarValor}
            tipoContribuyente={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

export default FormularioTipoContribuyenteCV;
